import React from 'react';
import DatePicker from 'react-datepicker';
import { getYear, getMonth } from 'date-fns';
import {
  Select,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { format, parseISO, isValid } from 'date-fns';

const currentBuddhistYear = new Date().getFullYear() + 543;
const years = Array.from({ length: 91 }, (_, i) => currentBuddhistYear - 80 + i);
const months = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
];

const CustomInput = React.forwardRef(({ onClick, displayValue, ...rest }, ref) => (
  <InputGroup>
    <Input
      {...rest}
      ref={ref}
      value={displayValue}
      onClick={onClick}
      readOnly
      placeholder={rest.monthOnly ? "เดือน/ปปปป" : "วว/ดด/ปปปป"}
      cursor="pointer"
      autoComplete="off"
    />
    <InputRightElement onClick={onClick} cursor="pointer">
      <FaCalendarAlt color="gray.300" />
    </InputRightElement>
  </InputGroup>
));

const ThaiDatePicker = ({ value, onChange, name, minDate, maxDate, monthOnly = false, ...rest }) => {
  const selectedDate = value && typeof value === 'string' && isValid(parseISO(value)) ? parseISO(value) : null;

  // เปลี่ยนการแสดงผลตามโหมด
  const displayValueForInput = selectedDate
    ? monthOnly
      ? `${months[getMonth(selectedDate)]} ${getYear(selectedDate) + 543}`
      : format(selectedDate, 'dd/MM/') + (getYear(selectedDate) + 543)
    : '';
  
  const handleDateChange = (date) => {
    const gregorianValue = date ? format(date, 'yyyy-MM-dd') : '';
    const event = {
      target: {
        name: name,
        value: gregorianValue,
      },
    };
    onChange(event);
  };

  return (
    <DatePicker
      selected={selectedDate}
      onChange={handleDateChange}
      minDate={minDate}
      maxDate={maxDate}
      showMonthYearPicker={monthOnly} // เปลี่ยนโหมดปฏิทิน
      customInput={<CustomInput displayValue={displayValueForInput} monthOnly={monthOnly} {...rest} />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <HStack justifyContent="space-between" p={2} bg="gray.50">
          <IconButton
            aria-label="Previous Month"
            icon={<FaChevronLeft />}
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            size="sm"
          />
          <HStack>
            {/* ถ้าไม่ใช่โหมดเลือกเดือนอย่างเดียว ถึงจะแสดง dropdown เดือน */}
            {!monthOnly && (
              <Select
                size="sm"
                width="130px"
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
              >
                {months.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </Select>
            )}
            <Select
              size="sm"
              width="90px"
              value={getYear(date) + 543}
              onChange={({ target: { value } }) => changeYear(value - 543)}
            >
              {years.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </Select>
          </HStack>
          <IconButton
            aria-label="Next Month"
            icon={<FaChevronRight />}
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            size="sm"
          />
        </HStack>
      )}
      formatWeekDay={nameOfDay => nameOfDay.substring(0, 1)}
    />
  );
};

export default ThaiDatePicker;